import { USER_API_BASE_URL } from 'constants/config';
import { isEmpty } from 'lodash';

import httpRequest from './config/HttpRequest';

// const request = axios.create({
//   baseURL: USER_API_BASE_URL,
//   timeout: REQUEST_TIMEOUT,
// });

export type GetUserRequest = {
  pageNo: number;
  orderType?: number;
  orderBy?: string;
  search?: string;
  isActive?: boolean;
  limit?: number;
};

export type TimeZone = {
  tzCode: string;
  utc?: string;
  label?: string;
  name?: string;
};

export type UserType = {
  id?: string;
  email: string;
  password?: string;
  confirmPassword?: string;
  userName: string;
  firstName: string;
  lastName: string;
  deviceId?: string;
  timeZone: string | TimeZone;
  gender: string;
  isActive: boolean;
  isDeleted: boolean;
  notes?: string | undefined;
  phoneNumber?: string;
  role: string;
  shouldUpdatePassword?: boolean;
  isSaveAddButton: boolean;
};

export type UserResponseType = {
  id?: string;
  email: string;
  userProfile?: File;
  password?: string;
  userName: string;
  firstName: string;
  lastName: string;
  deviceId?: string;
  timeZone: string | TimeZone;
  gender: string;
  isActive: boolean;
  isDeleted: boolean;
  notes: string;
  phoneNumber?: string;
  role: {
    id?: string;
  };
  shouldUpdatePassword?: boolean;
  isSaveAddButton: boolean;
};

export const UserDefaultValues = {
  data: {
    email: '',
    password: '',
    userName: '',
    firstName: '',
    lastName: '',
    deviceId: undefined,
    gender: '',
    isActive: false,
    isDeleted: false,
    notes: '',
    phoneNumber: '',
    role: {
      id: '',
    },
    shouldUpdatePassword: false,
    timeZone: '',
    isSaveAddButton: true,
  },
  message: '',
};

type UserResponse = {
  data: UserResponseType;
  message: string;
};

export type PaginatedUsers = {
  data: UserType[];
  total: number;
  pageNo: number;
  last_page: number;
};

export type UpdateUserStatusType = {
  id: string;
  isActive: boolean;
};

const usersApi = {
  getUsers: async (params: GetUserRequest, headers?: Record<string, string>): Promise<PaginatedUsers> => {
    try {
      const response = await httpRequest.request({
        baseURL: USER_API_BASE_URL,
        url: '/user',
        method: 'GET',
        params,
        header: headers,
      });
      return response;
    } catch (error) {
      throw new Error(error as string);
    }
  },

  getUser: async (userId: string, headers?: Record<string, string>): Promise<UserResponse> => {
    try {
      if (!isEmpty(userId)) {
        const response = await httpRequest.request({
          baseURL: USER_API_BASE_URL,
          url: `/user/${userId}`,
          method: 'GET',
          header: headers,
        });
        return response;
      }
      return UserDefaultValues;
    } catch (error) {
      throw new Error(error as string);
    }
  },

  saveUser: async (body: UserType): Promise<UserResponse> => {
    try {
      const userId = body.id;
      const requestParams: {
        baseURL: string;
        url: string;
        method: 'POST' | 'PUT';
        data: UserType;
      } = {
        baseURL: USER_API_BASE_URL,
        url: '/user/add',
        method: 'POST',
        data: body,
      };

      if (!isEmpty(userId)) {
        requestParams.url = `/user/${userId}`;
        requestParams.method = 'PUT';
      }

      const response = await httpRequest.request(requestParams);
      return response;
    } catch (error) {
      throw { ...error };
    }
  },

  updateUserStatus: async (body: UpdateUserStatusType): Promise<UserResponse> => {
    const userId = body.id;
    try {
      const response = await httpRequest.request({
        baseURL: USER_API_BASE_URL,
        url: `/user/status/${userId}`,
        method: 'PATCH',
        data: body,
      });
      return response;
    } catch (error) {
      throw new Error(error as string);
    }
  },
};

export default usersApi;
